export const BTN_SAVE = "SPEICHERN";
export const LEGENDE_TITLE = "Legende";
export const SLD_TITLE = "Skalierung";
export const SLD_LEGEND = "Legendenskalierung";
export const SLD_PLANNER_ZOOM = "Planskalierung";
export const SLD_PROBES_ZOOM = "Probepunktskalierung";
export const POPUP_SCREENSHOT_TITLE = "Bildausschnitt speichern";
export const POPUP_SCREENSHOT_TOP_LEFT = "Abbildungsnummer";
export const POPUP_SCREENSHOT_TOP_RIGHT = "Bildunterschrift";